import { api } from './api';
import {
  beginDisplayTimeZoneReport,
  isCurrentDisplayTimeZoneReport,
  setDisplayTimeZone,
} from './displayTimeZone';
import { listIanaTimeZones } from '../utils/ianaTimeZones';

export interface UserTimeZoneState {
  timeZone: string | null;
  isLocked: boolean;
}

export function readDeviceTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export { listIanaTimeZones };

export async function fetchUserTimeZone(): Promise<UserTimeZoneState> {
  const response = await api.get<{
    timeZone?: string | null;
    isLocked?: boolean;
  }>('/v1/profile/timeZone');
  return {
    timeZone: response.timeZone ?? null,
    isLocked: response.isLocked === true,
  };
}

export async function saveUserTimeZonePreference(
  timeZone: string,
  isLocked: boolean,
): Promise<UserTimeZoneState> {
  const response = await api.patch<{
    timeZone: string;
    isLocked: boolean;
  }>('/v1/profile/timeZone', { timeZone, isLocked });
  return { timeZone: response.timeZone, isLocked: response.isLocked };
}

/** Report the device zone after sign-in, then show the saved preference. A locked preference is left unchanged. */
export async function reportDeviceTimeZone(): Promise<void> {
  const token = beginDisplayTimeZoneReport();
  try {
    const timeZone = readDeviceTimeZone();
    if (timeZone) {
      try {
        await api.post('/v1/profile/timeZone:recordLogin', { timeZone });
      } catch {
        // Still read a previously saved preference.
      }
    }
    const state = await fetchUserTimeZone();
    if (!isCurrentDisplayTimeZoneReport(token)) {
      return;
    }
    setDisplayTimeZone(state.timeZone);
  } catch {
    // Sign-in still succeeds when the zone report fails.
  }
}
